import React from "react";
import PropTypes from "prop-types";
import LastUpdated from "../../../../common/partials/LastUpdated/LastUpdated";
// import Table from "../../../../common/components/Table";

export default class Commercials extends React.Component{

    static propTypes = {
        serviceDetail: PropTypes.object,
    }

    render() {
        const {serviceDetail} = this.props;
        const billingGroup = serviceDetail.billing_group;        
        const startDate = billingGroup.contract_start_date === "0000-00-00" || billingGroup.contract_start_date === null
            ? ""
            : billingGroup.contract_start_date
        // This will remain commented until we complete DP Pricing Epic
        // const baseCostInformation = serviceDetail.base_cost;
        // const volumeTiers = serviceDetail.volume_tiers;
        // const baseCostTableHeaders = [
        //     <Table.Header key="country">Supported Country List</Table.Header>,
        //     <Table.Header key="vol-tier">Volume Tier</Table.Header>,
        //     <Table.Header key="t-min">Tier Min</Table.Header>,
        //     <Table.Header key="t-max">Tier Max</Table.Header>,
        //     <Table.Header key="cost">Cost</Table.Header>,
        // ];


        return(
            <div className="detail-info">
                <div>
                    <span>Commercials:</span>
                    <p>
                        Contract Start Date: <LastUpdated lastUpdated={startDate}   />
                    </p>
                    <p>
                        Contract Term (months): {billingGroup.contract_term}
                    </p>
                    <p>
                        Notification Period (days): {billingGroup.cancel_days_notice}
                    </p>
                    <p>
                        Monthly Minimum Volume: {billingGroup.monthly_aggregate_volume
                        ? billingGroup.monthly_aggregate_volume
                        : "" }
                    </p>
                    <p>
                        Billing Group Name: {billingGroup.billing_group_name}
                    </p>
                    <p>
                        Invoice Name: {billingGroup.invoice_name}
                    </p>
                </div>

                <div>
                    <span>Pricing Details:</span>
                    <p>
                        Is Fixed: {billingGroup.has_fixed === true ? "True" : "False"}
                    </p>
                    <p>
                        Model: Per {billingGroup.price_model}
                    </p>
                    <p>
                        Currency: {billingGroup.currency}
                    </p>
                    <p>
                        Billing Period (months): {billingGroup.billing_period}
                    </p>
                </div>

                <br/>

                {/*
                This table below will remain commented until we complete the DP Pricing Epic.
                */}
                {/*{baseCostInformation*/}
                {/*    ? baseCostInformation.length > 0*/}
                {/*        ? (*/}
                {/*            <div className="base-cost-sticky-table-container">*/}
                {/*                <h4><b>Base Cost Information</b></h4>*/}

                {/*                <Table*/}
                {/*                    className="sticky-table"*/}
                {/*                    headers={baseCostTableHeaders}*/}
                {/*                >*/}
                {/*                        {volumeTiers*/}
                {/*                            ? (volumeTiers.map((baseCost, idx) => {*/}
                {/*                                return (*/}
                {/*                                    <tr key={idx}>*/}
                {/*                                        /!*Country does not populate at this time*/}
                {/*                                        have to discuss more on this to make it work.*!/*/}
                {/*                                        <td>{baseCost.country}</td>*/}
                {/*                                        <td>{baseCost.tier_index}</td>*/}
                {/*                                        <td>{baseCost.min_volume}</td>*/}
                {/*                                        <td>{baseCost.max_volume}</td>*/}
                {/*                                        <td>{baseCost.tier_cost}</td>*/}
                {/*                                    </tr>*/}
                {/*                                )}))*/}
                {/*                            : null*/}
                {/*                        }*/}
                {/*                    </Table>*/}
                {/*            </div>*/}
                {/*        )*/}
                {/*        : (*/}
                {/*            <div>*/}
                {/*                <h4><b>Base Cost Information</b></h4>*/}
                {/*                <p> Base Cost / Pricing Information Not Available for the associated Billing Group.</p>*/}
                {/*                <p> Please update the details for the Billing Group -*/}
                {/*                    {serviceDetail.billing_group.billing_group_name}{" "} which is associated with*/}
                {/*                    {serviceDetail.service_detail.service_name}{" "} to view the base cost pricing breakdown.*/}
                {/*                </p>*/}
                {/*            </div>*/}
                {/*        )*/}
                {/*    : null}*/}

                <div>
                    <h4><b>Base Cost Information</b></h4>
                    <p> Base Cost / Pricing Information Not Available Currently. Coming Soon.</p>
                </div>
            </div>
        )
    }
}
